import { render } from "./CommonHeader.vue?vue&type=template&id=1d319150&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"

import "./CommonHeader.vue?vue&type=style&index=0&id=1d319150&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d319150"]])

export default __exports__